import React from "react";
import { Helmet } from "react-helmet";
const BlackfridayHelmet = ({ title }) => {
  return (
    <Helmet>
      
      <title>
       Best Black Friday Deals 2025 for Website Design
      </title>
      <meta
        name="description"
        content="Black Friday 2025 is the best time to upgrade your website. Grab up to 80% off web design and development from $199. Get your deal today!"
      />
    </Helmet>
  );
};

export default BlackfridayHelmet;
